import { Box } from '@mui/material';
import ActionButtonsFormik from 'components/forms/ActionButtonsFormik';
import { ContainerFormFormik } from 'components/shared/container_form_formik';
import InputComLabelFormik from 'components/shared/custom_input_label_formik';
import { useFormik } from 'formik';
import { useState } from 'react';
import { useFormularioSecretariaMunicipalAgriculturaStore } from '../../../../../../stores/forms/formularioAgricultura.store';
import { step1ValidationSchema } from './step1.validation';
const Step1: React.FC = () => {
  const { formulario, setPartialForm, salvarRascunho } =
    useFormularioSecretariaMunicipalAgriculturaStore();
  const [submittedOnce, setSubmittedOnce] = useState(false);

  const handleSave = async (values: any) => {
    setPartialForm('nome_secretaria', values.nome_secretaria);
    setPartialForm('endereco', values.endereco);
    setPartialForm('endereco_numero', values.endereco_numero);
    setPartialForm('bairro', values.bairro);
    setPartialForm('cep', values.cep);
    setPartialForm('email', values.email);
    setPartialForm('telefone', values.telefone);
    setPartialForm('telefone2', values.telefone2);
    setPartialForm('nome_responsavel', values.nome_responsavel);
    setPartialForm('email_responsavel', values.email_responsavel);
    setPartialForm('step_atual', 2);
    salvarRascunho();
  }

  const formik = useFormik({
    initialValues: {
      nome_secretaria: formulario?.nome_secretaria,
      endereco: formulario?.endereco,
      endereco_numero: formulario?.endereco_numero || '',
      bairro: formulario?.bairro,
      cep: formulario?.cep,
      email: formulario?.email,
      telefone: formulario?.telefone,
      telefone2: formulario?.telefone2,
      nome_responsavel: formulario?.nome_responsavel,
      email_responsavel: formulario?.email_responsavel,
    },
    validationSchema: step1ValidationSchema,
    validateOnChange: true,
    validateOnBlur: submittedOnce,
    onSubmit: (values) => {
      handleSave(values);
    },
  });


  return (
    <>
      <ContainerFormFormik title='Informações Gerais' onSubmit={formik.handleSubmit}>
        <Box
          sx={{ borderBottom: 1, borderColor: 'divider' }}
          gap={4}
          display={'flex'}
          flexDirection={'column'}
        >

          <InputComLabelFormik
            formik={formik}
            label='nome_secretaria'
            labelTexto='Nome da Secretaria Municipal'
            placeholder='Secretaria Municipal de Agricultura'
            required
          />

          <Box display={'flex'} gap={2}>
            <InputComLabelFormik
              formik={formik}
              label='endereco'
              labelTexto='Endereço /Rua/Avenida'
              placeholder='Rua das Flores, 123'
              required
            />
            <InputComLabelFormik
              formik={formik}
              label='endereco_numero'
              labelTexto='Número'
              placeholder='123'
              width='20%'
              mask='numero'
            />
          </Box>

          <InputComLabelFormik
            formik={formik}
            label='bairro'
            labelTexto='Bairro'
            placeholder='Jardim Cuiabá'
            required
          />

          <InputComLabelFormik
            formik={formik}
            label='cep'
            mask='cep'
            maxLength={9}
            labelTexto='CEP'
            placeholder='12345-678'
            required
          />

          <InputComLabelFormik
            formik={formik}
            label='email'
            labelTexto='Email'
            placeholder='exemplo@email.com'
            required
            type='email'
          />

          <InputComLabelFormik
            formik={formik}
            label='telefone'
            mask='telefone'
            labelTexto='Telefone'
            placeholder='(12) 3456-7890'
            required
            maxLength={15}
          />

          <InputComLabelFormik
            formik={formik}
            label='telefone2'
            mask='telefone'
            labelTexto='Telefone 2'
            placeholder='(12) 3456-7890'
            required
            maxLength={15}
          />

          <InputComLabelFormik
            formik={formik}
            label='nome_responsavel'
            labelTexto='Nome Completo do(a) Secretário(a) Municipal ou do(a) Responsável pelo Órgão Municipal'
            placeholder='João da Silva'
            required
          />

          <InputComLabelFormik
            formik={formik}
            label='email_responsavel'
            labelTexto='Email do(a) Secretário(a) Municipal ou do(a) Responsável pelo Órgão Municipal'
            placeholder='exemplo@email.com'
            type='email'
            required
          />
        </Box>
        <ActionButtonsFormik
          disabled={
            formik.isSubmitting
          }
        />
      </ContainerFormFormik>
    </>
  );
};

export default Step1;
